module.exports = __webpack_public_path__ + "static/media/CROWN-WP-1.c82b10e2.jpg";